import { render, staticRenderFns } from "./RelativeTimePickerInput.vue?vue&type=template&id=8993d83a&"
import script from "./RelativeTimePickerInput.vue?vue&type=script&lang=js&"
export * from "./RelativeTimePickerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports